import { email, minValue, number } from "react-admin";

import { isNullUndEmpty } from "../general";

export const validateEmail = [email()];

export const validateNumberPositive = [number(), minValue(0)];

export const confirmPasswordValidator = (value, values) => {
	if (value !== values["password"]) {
		return "osfc.messages.validation.confirmPasswordInvalid";
	}
};

export const validateUnique =
	(field, msg = "osfc.messages.validation.unique") =>
	(val, vals, params) => {
		const data = vals.data;
		if (data) {
			const arr = data.filter((x) => x && x[field] && x[field] === val);
			if (arr.length > 1) return msg;
		}
	};

export const rangeValue =
	(min, max, message = "osfc.messages.validation.rangeValue") =>
	(value) => {
		const n = Number(value);
		if (n < min || n > max) {
			return { message, args: { min, max } };
		}
	};

export const validateInteger = (value) => {
	if (value && !Number.isInteger(value)) {
		return "osfc.messages.validation.integer";
	}
};

export const validatePositiveNumber = (translate) => (value) => {
	if (isNullUndEmpty(value)) return;
	if (value > 0) return;
	return translate("osfc.messages.validation.validatePositiveNumber");
};

export const validateLettersOnly = (value) => {
	if (!value) return undefined;
	const regex = /^[A-Z]+$/;
	return regex.test(value) ? undefined : "osfc.messages.validation.validateLettersOnly";
};

export const validateUUID = (value) => {
	if (!value) return undefined;
	const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
	return uuidRegex.test(value) ? undefined : "osfc.messages.validation.invalidUUID";
};
